import Link from "next/link";
import { useTranslations } from "next-intl";

import LinkArrowSvg from "@/public/svg/LinkArrow.svg";

import styles from "./storeLocator.module.scss";
const StoreLocator = () => {
  const t = useTranslations();
  return (
    <>
      <Link href={"/retailers"} legacyBehavior>
        <div className={styles.container}>
          <LinkArrowSvg />
          <p className={styles.link}>{t("storeLocator")}</p>
        </div>
      </Link>
    </>
  );
};

export default StoreLocator;
